import { z } from 'zod';

import { ListingActivityChangeSchema } from './listing-activity-change';
import { ListingActivityCategory, ListingActivityFieldSchema, listingActivityFieldIds } from './listing-activity-fields';
import { buildQueryString } from '../../../utils/querystring';
import { makeEndpoint } from '../../common';

export * from './listing-activity-change';

export enum ListingActivityAction {
  CREATED = 'created',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
  RESOURCE_REMOVED = 'resourceRemoved',
}

export const GetListingActivitiesQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  cursor: z.string().optional(),
  from: z.string().datetime({ offset: true }).optional(),
  to: z.string().datetime({ offset: true }).optional(),
  action: z.nativeEnum(ListingActivityAction).optional(),
  category: z.nativeEnum(ListingActivityCategory).optional(),
  fields: z
    .string()
    .transform((value) => value.split(','))
    .pipe(z.array(ListingActivityFieldSchema).min(1).max(listingActivityFieldIds.length))
    .optional(),
});

export const GetListingActivitiesResponseSchema = z.object({
  updates: z.array(
    z.object({
      eventId: z.string(),
      action: z.nativeEnum(ListingActivityAction),
      occurredAt: z.string(),
      actorUserId: z.string().nullable(),
      actorName: z.string().nullable(),
      previousAction: z.nativeEnum(ListingActivityAction).nullable().optional(),
      changes: z.array(ListingActivityChangeSchema),
    }),
  ),
  nextCursor: z.string().nullable(),
});
export type GetListingActivitiesResponse = z.infer<typeof GetListingActivitiesResponseSchema>;

export const GetListingActivitiesEndpoint = makeEndpoint({
  method: 'GET',
  url: ({
    brandId,
    listingId,
    query,
  }: {
    brandId: string;
    listingId: string;
    query: z.input<typeof GetListingActivitiesQuerySchema>;
  }) =>
    `v3/brands/${brandId}/dashboard/listings/${listingId}/activities${
      Object.keys(query).length ? `?${buildQueryString(query)}` : ''
    }`,
  responseSchema: GetListingActivitiesResponseSchema,
  querySchema: GetListingActivitiesQuerySchema,
  requestSchema: z.void(),
});
